import { ClusterOptimization } from '@cast/types';
import { toNumOrZero } from '@cast/utils';

export const getMonthlySavingsFromOptimization = (
  optimization?: ClusterOptimization
): number => {
  const { workloadAutoscaler, infrastructureAutoscaler } = optimization ?? {};

  return Math.max(
    toNumOrZero(infrastructureAutoscaler?.cpuSavingsMonthly) +
      toNumOrZero(infrastructureAutoscaler?.memorySavingsMonthly) +
      toNumOrZero(workloadAutoscaler?.cpuSavingsMonthly) +
      toNumOrZero(workloadAutoscaler?.memorySavingsMonthly),
    0
  );
};
